module.exports = __webpack_public_path__ + "static/media/Rectangle 116.919eed16.png";